class Navbar {

    element;

    constructor(element) {

        if (!(element instanceof HTMLElement)) {
            throw new TypeError("Invalid HTMLElement");
        }

        this.element = element;
        this.mobileTriggers = this.element.querySelectorAll('.menu-toggle') ?? [];

        this.initMobileTriggerEvents();
        this.initNavOnScroll();
        this.initNavbarProgress();
    }

    toggleMobileNav = (e) => {
        e.preventDefault();

        const btn = e.currentTarget;
        const isAlreadyOpen = window.document.documentElement.classList.contains('site-menu-open');

        const btnText = btn.querySelector('.menu-toggle__text');
        const btnIcon = btn.querySelector('.menu-toggle__icon');

        if (btnText) {
            btnText.innerText = isAlreadyOpen ? 'Menu' : 'Close';
        }

        if (btnIcon) {
            btnIcon.innerHTML = isAlreadyOpen ? `<use xlink:href="#icon--menu">` : `<use xlink:href="#icon--close">`;
        }

        btn.classList.toggle('open');
        btn.classList.toggle('close');

        window.document.documentElement.classList.toggle('site-menu-open');
    }

    initMobileTriggerEvents = () => {
        this.mobileTriggers.forEach(el => el.addEventListener('click', this.toggleMobileNav.bind(this)));
    }

    updateNavbarProgress = () => {
        const perc = ((document.scrollingElement.scrollTop + document.documentElement.clientHeight) / document.body.clientHeight) * 100;
        document.querySelector('#navbar__progress').style.width = perc + '%';
    }

    initNavbarProgress = () => {
        document.addEventListener('scroll', this.updateNavbarProgress.bind(this), { passive: true });
        this.updateNavbarProgress();
    }

    updateNavOnScroll = () => {

        const headerHeight = document.querySelector('#page-header').offsetHeight - 170;
        const navbarHeight = this.element.offsetHeight;
        const scroll = document.scrollingElement.scrollTop;

        this.element.classList.toggle('affixed', scroll > (navbarHeight / 2));
    }

    initNavOnScroll = () => {
        window.addEventListener('scroll', this.updateNavOnScroll.bind(this), { passive: false });
        this.updateNavOnScroll()
    }
}

export default Navbar;
